import React from 'react';
import CountUp from 'react-countup';
import drPereiraBlue from '../../images/about-page/dr-pereira-blue.png';

const AboutImproved = (props) => {
    return (
        <section className={"about-improved-section " + props.hclass}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="about-header text-center mb-5">
                            <h3 className="subtitle">Pioneering Regenerative Medicine in Florida</h3>
                        </div>
                    </div>
                </div>
                
                <div className="row">
                    <div className="col-lg-8 mx-auto">
                        <div className="about-content">
                            <p className="lead-text">
                                Amped Therapeutics represents Florida's pioneering approach to regenerative medicine, uniquely positioned to offer advanced cellular therapies previously only available through international medical tourism. We specialize in cutting-edge stem cell therapy, orthobiologics, and interventional pain management, providing patients with innovative alternatives to traditional treatments.
                            </p>
                            <p>
                                Our state-of-the-art centers combine advanced technology with compassionate care under the leadership of Medical Director Dr. Eugene G. Pereira, MD, ABA-PM (American Board of Anesthesiology Subspecialty Pain Management, recognized by American Board of Medical Specialties), FIPP, ABIPP. Licensed in multiple states including Florida, New York, New Jersey, and Utah. With over 25+ years of clinical experience, Dr. Pereira has established the region's premier destination for cutting-edge stem cell treatments, utilizing Florida's progressive regulatory framework to deliver world-class care without leaving the United States.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row mt-5">
                    <div className="col-lg-12">
                        <div className="stats-section">
                            <div className="row">
                                <div className="col-md-3 col-sm-6 mb-4">
                                    <div className="stat-card text-center">
                                        <div className="stat-icon">
                                            <i className="fas fa-trophy"></i>
                                        </div>
                                        <h3><CountUp end={25} enableScrollSpy />+</h3>
                                        <p>Years of Experience</p>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-6 mb-4">
                                    <div className="stat-card text-center">
                                        <div className="stat-icon">
                                            <i className="fas fa-dna"></i>
                                        </div>
                                        <h3>CERTIFIED</h3>
                                        <p>Highest Quality, Ethically Sourced Cells</p>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-6 mb-4">
                                    <div className="stat-card text-center">
                                        <div className="stat-icon">
                                            <i className="fas fa-headset"></i>
                                        </div>
                                        <h3>24/7</h3>
                                        <p>Patient Support</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-5">
                    <div className="col-lg-10 mx-auto">
                        <div className="dr-pereira-section">
                            <div className="row align-items-center">
                                <div className="col-lg-4 text-center mb-4 mb-lg-0">
                                    <img src={drPereiraBlue} alt="Dr. Eugene G. Pereira" className="dr-pereira-image" />
                                </div>
                                <div className="col-lg-8">
                                    <div className="dr-pereira-content text-center">
                                        <h2 className="dr-name">Dr. Eugene G. Pereira, MD</h2>
                                        <h4 className="dr-title">Medical Director & Founder</h4>
                                        <p className="lead-paragraph">
                                            Dr. Pereira combines over two decades of interventional pain management expertise with cutting-edge cellular therapies. His patient-first philosophy and innovative approach have established Amped Therapeutics as the region's premier destination for advanced regenerative treatments.
                                        </p>
                                        <p className="credentials-paragraph">
                                            Board-certified in Pain Management with elite FIPP and ABIPP credentials, Dr. Pereira represents the highest specialization levels in regenerative medicine. With over 1000 procedures performed, he trains other physicians and serves as an industry consultant while maintaining affiliations with premier hospitals including Sarasota Memorial and Lee Memorial.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutImproved;